webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(167);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	__webpack_require__(176);
	
	var _vueRouter = __webpack_require__(443);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueHead = __webpack_require__(438);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	var _vueGa = __webpack_require__(437);
	
	var _vueGa2 = _interopRequireDefault(_vueGa);
	
	var _App = __webpack_require__(439);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(171);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _video = __webpack_require__(440);
	
	var _video2 = _interopRequireDefault(_video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueHead2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{
	    path: '/',
	    name: 'home'
	  }, {
	    path: '/:slug',
	    name: 'video',
	    component: _video2.default
	  }]
	});
	
	(0, _vueGa2.default)(router, 'UA-109921908-1');
	
	new _vue2.default({
	  el: '#app',
	  store: _store2.default,
	  router: router,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(113);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _prismicJavascript = __webpack_require__(429);
	
	var _prismicJavascript2 = _interopRequireDefault(_prismicJavascript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiEndpoint = 'https://shes-a-show.prismic.io/api/v2';
	
	exports.default = {
	  getPosts: function getPosts() {
	    return new _promise2.default(function (resolve, reject) {
	      _prismicJavascript2.default.getApi(apiEndpoint).then(function (api) {
	        return api.query('');
	      }).then(function (response) {
	        resolve(response.results);
	      }, function (err) {
	        console.log('Something went wrong: ', err);
	        reject();
	      });
	    });
	  }
	};

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_POSTS = exports.GET_POSTS = 'GET_POSTS';
	var SET_SINGLE = exports.SET_SINGLE = 'SET_SINGLE';

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(167);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(112);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _main = __webpack_require__(172);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var DEBUG = ("production") === 'development';
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    main: _main2.default
	  },
	  strict: DEBUG
	});

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(180);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _regenerator = __webpack_require__(183);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(179);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _actions, _mutations;
	
	var _prismic = __webpack_require__(169);
	
	var _prismic2 = _interopRequireDefault(_prismic);
	
	var _actionTypes = __webpack_require__(170);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _mutationTypes = __webpack_require__(173);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _slugify = __webpack_require__(433);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _prismicDom = __webpack_require__(428);
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  colophon: {
	    data: {
	      text: [{
	        text: ''
	      }]
	    }
	  },
	  about: {
	    data: {
	      text: ''
	    }
	  },
	  biographies: '',
	  works: [],
	  single: {
	    data: {
	      text: [{
	        text: ''
	      }],
	      media: '',
	      year: ''
	    }
	  }
	};
	
	var actions = (_actions = {}, (0, _defineProperty3.default)(_actions, actionTypes.GET_POSTS, function (_ref) {
	  var _this = this;
	
	  var commit = _ref.commit,
	      state = _ref.state;
	  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.t0 = commit;
	            _context.t1 = mutationTypes.SET_POSTS;
	            _context.next = 4;
	            return _prismic2.default.getPosts();
	
	          case 4:
	            _context.t2 = _context.sent;
	            (0, _context.t0)(_context.t1, _context.t2);
	
	          case 6:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this);
	  }))();
	}), (0, _defineProperty3.default)(_actions, actionTypes.SET_SINGLE, function (_ref2, post) {
	  var commit = _ref2.commit,
	      state = _ref2.state;
	
	  commit(mutationTypes.SET_SINGLE, post);
	}), _actions);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, mutationTypes.SET_POSTS, function (state, data) {
	  state.colophon = data.filter(function (e) {
	    return e.type === 'colophon';
	  })[0];
	  state.about = data.filter(function (e) {
	    return e.type === 'about';
	  })[0];
	  state.biographies = _prismicDom2.default.RichText.asHtml(data.filter(function (e) {
	    return e.type === 'biographies';
	  })[0].data.text, function (doc) {
	    return doc;
	  });
	  state.works = data.filter(function (e) {
	    return e.type === 'work';
	  });
	  state.works = state.works.map(function (e) {
	    e.data.credits = _prismicDom2.default.RichText.asHtml(e.data.credits, function (doc) {
	      return doc;
	    });
	    return e;
	  });
	  state.works = state.works.map(function (e) {
	    e.slugs[0] = (0, _slugify2.default)(e.slugs[0]);
	    return e;
	  });
	  state.works = state.works.sort(function (a, b) {
	    if (a.data.order > b.data.order) {
	      return 1;
	    } else if (a.data.order < b.data.order) {
	      return -1;
	    } else {
	      return 0;
	    }
	  });
	}), (0, _defineProperty3.default)(_mutations, mutationTypes.SET_SINGLE, function (state, post) {
	  state.single = post;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  actions: actions,
	  mutations: mutations
	};

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_POSTS = exports.SET_POSTS = 'SET_POSTS';
	var SET_SINGLE = exports.SET_SINGLE = 'SET_SINGLE';

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(112);
	
	var _vueTyper = __webpack_require__(444);
	
	var _away = __webpack_require__(168);
	
	var _away2 = _interopRequireDefault(_away);
	
	var _perfectScrollbar = __webpack_require__(427);
	
	var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    VueTyper: _vueTyper.VueTyper
	  },
	  data: function data() {
	    return {
	      titleImg: __webpack_require__(435),
	      closeIcn: __webpack_require__(436),
	      titleActive: true,
	      quotesCollapsed: false,
	      aboutCollapsed: false,
	      indexCollapsed: false,
	      colophonText: '**',
	      textIndex: true,
	      imageIndex: false,
	      navHidden: false,
	      mobileQuotes: false,
	      mobileAbout: false,
	      timer: {},
	      imageSlider: {
	        index: 0
	      },
	      ps: [],
	      scrollConfig: {
	        minScrollbarLength: 80,
	        suppressScrollX: true
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['GET_POSTS']), {
	    showNavigation: function showNavigation() {
	      this.quotesCollapsed = false;
	      this.aboutCollapsed = false;
	      this.indexCollapsed = false;
	    },
	    hideNavigation: function hideNavigation() {
	      this.quotesCollapsed = true;
	      this.aboutCollapsed = true;
	      this.indexCollapsed = true;
	      this.mobileQuotes = false;
	      this.mobileAbout = false;
	      this.scrollUpAllQuarts();
	    },
	    toggleNavigation: function toggleNavigation() {
	      if (this.quotesCollapsed && this.aboutCollapsed && this.indexCollapsed) {
	        this.quotesCollapsed = false;
	        this.aboutCollapsed = false;
	        this.indexCollapsed = false;
	      } else {
	        this.quotesCollapsed = true;
	        this.aboutCollapsed = true;
	        this.indexCollapsed = true;
	        this.mobileQuotes = false;
	        this.mobileAbout = false;
	      }
	      this.scrollUpAllQuarts();
	    },
	    toggleIndex: function toggleIndex() {
	      this.indexCollapsed = !this.indexCollapsed;
	      document.getElementById('index').scrollTop = 0;
	    },
	    toggleAbout: function toggleAbout() {
	      this.aboutCollapsed = !this.aboutCollapsed;
	      document.getElementById('about').scrollTop = 0;
	    },
	    toggleQuotes: function toggleQuotes() {
	      this.quotesCollapsed = !this.quotesCollapsed;
	      document.getElementById('credits').scrollTop = 0;
	    },
	    showMobileAbout: function showMobileAbout() {
	      this.mobileQuotes = false;
	      this.aboutCollapsed = false;
	      this.indexCollapsed = true;
	      this.mobileAbout = !this.mobileAbout;
	      document.getElementById('about').scrollTop = 0;
	    },
	    showMobileQuotes: function showMobileQuotes() {
	      this.mobileAbout = false;
	      this.quotesCollapsed = false;
	      this.indexCollapsed = true;
	      this.mobileQuotes = !this.mobileQuotes;
	      document.getElementById('credits').scrollTop = 0;
	    },
	    scrollUpAllQuarts: function scrollUpAllQuarts() {
	      document.getElementById('index').scrollTop = 0;
	      document.getElementById('about').scrollTop = 0;
	      document.getElementById('credits').scrollTop = 0;
	    },
	    toggleCustomScrollbars: function toggleCustomScrollbars(mq) {
	      if (mq.matches) {
	        this.destroyCustomScrollbars();
	      } else {
	        this.initCustomScrollbars();
	      }
	    },
	    initCustomScrollbars: function initCustomScrollbars() {
	      var _this = this;
	
	      console.log('init scrollbars');
	      window.setTimeout(function () {
	        _this.ps[0] = new _perfectScrollbar2.default('#index', _this.scrollConfig);
	        _this.ps[1] = new _perfectScrollbar2.default('#about', _this.scrollConfig);
	        _this.ps[2] = new _perfectScrollbar2.default('#credits', _this.scrollConfig);
	      }, 500);
	    },
	    destroyCustomScrollbars: function destroyCustomScrollbars() {
	      console.log('destroy scrollbars');
	      if (this.ps[0]) {
	        console.log('destroy scrollbars yepp');
	        this.ps[0].destroy();
	        this.ps[1].destroy();
	        this.ps[2].destroy();
	        this.ps[0] = null;
	        this.ps[1] = null;
	        this.ps[2] = null;
	      }
	    }
	  }),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.GET_POSTS();
	
	    if (this.$route.name === 'video') {
	      this.hideNavigation();
	    }
	
	    if (!window.matchMedia('(max-width: 900px)').matches) {
	      this.initCustomScrollbars();
	    }
	
	    this.timer = (0, _away2.default)(3000);
	    this.timer.on('idle', function () {
	      if (_this2.$route.name === 'video' && _this2.quotesCollapsed && _this2.indexCollapsed && _this2.aboutCollapsed) {
	        _this2.navHidden = true;
	      }
	    });
	    this.timer.on('active', function () {
	      if (_this2.$route.name === 'video') {
	        _this2.navHidden = false;
	      }
	    });
	
	    if (window.matchMedia) {
	      var mq = window.matchMedia('(max-width: 900px)');
	      mq.addListener(this.toggleCustomScrollbars);
	      this.toggleCustomScrollbars(mq);
	    }
	  },
	
	  watch: {
	    'main.colophon.data.text': function mainColophonDataText() {
	      var _this3 = this;
	
	      this.main.colophon.data.text.map(function (t) {
	        _this3.colophonText = _this3.colophonText + t.text + '\n';
	      });
	    },
	    $route: function $route(to, from) {
	      if (to.name === 'video') {
	        this.hideNavigation();
	
	        this.imageSlider.index = this.main.works.find(function (e) {
	          return e.slugs[0] === to.params.slug;
	        }).data.order - 1;
	      } else {
	        this.mobileAbout = false;
	        this.mobileQuotes = false;
	        this.showNavigation();
	        this.scrollUpAllQuarts();
	      }
	    }
	  }
	};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(114);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(112);
	
	var _youtubePlayer = __webpack_require__(452);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'video',
	  data: function data() {
	    return {
	      player: {},
	      title: '',
	      image: ''
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['SET_SINGLE']), {
	    setSingleActionWrapper: function setSingleActionWrapper() {
	      var _this = this;
	
	      this.SET_SINGLE(this.main.works.find(function (e) {
	        return e.slugs[0] === _this.$route.params.slug;
	      }));
	    },
	    toggleVideo: function toggleVideo() {
	      var _this2 = this;
	
	      this.$emit('hideNav');
	      if (this.player.getPlayerState) {
	        this.player.getPlayerState().then(function (state) {
	          if (state === 1) {
	            _this2.player.pauseVideo();
	          } else {
	            _this2.player.playVideo();
	          }
	        });
	      }
	    }
	  }),
	  head: {
	    title: function title() {
	      return {
	        inner: this.title
	      };
	    },
	    meta: function meta() {
	      return [{
	        property: 'og:image',
	        content: this.image
	      }];
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['main'])),
	  mounted: function mounted() {
	    if (this.main.works && this.main.works.length > 0) {
	      this.setSingleActionWrapper();
	    }
	  },
	
	  watch: {
	    'main.works': function mainWorks() {
	      this.setSingleActionWrapper();
	    },
	    $route: function $route(to, from) {
	      this.setSingleActionWrapper();
	    },
	    'main.single.data.video.embed_url': function mainSingleDataVideoEmbed_url() {
	      var _this3 = this;
	
	      if (this.player.destroy) {
	        this.player.destroy();
	      }
	
	      this.player = (0, _youtubePlayer2.default)('video', {
	        playerVars: {
	          controls: 0,
	          loop: true,
	          modestbranding: 0,
	          showinfo: 1,
	          rel: 0
	        }
	      });
	
	      this.player.loadVideoById(this.main.single.data.video.embed_url.substr(this.main.single.data.video.embed_url.length - 11));
	
	      this.player.playVideo();
	
	      this.player.on('stateChange', function (event) {
	        if (event.data === 0) {
	          var i = 0;
	          if (_this3.main.single.data.order !== _this3.main.works.length) {
	            i = _this3.main.single.data.order;
	          }
	          console.log(i);
	          _this3.$router.push(_this3.main.works[i].slugs[0]);
	        }
	      });
	
	      this.title = this.main.single.data.title[0].text;
	      if (this.main.single.data.preview_image) {
	        this.image = this.main.single.data.preview_image.url;
	      }
	      this.$emit('updateHead');
	    }
	  }
	};

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGFhZ18xIiBkYXRhLW5hbWU9IkxhYWcgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzMuNCAzMy4yNSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM2Zjk7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5zaG93VGVrZW5nZWJpZWQgMjwvdGl0bGU+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjI5LjMzIDAgMTYuNzcgMTIuNTYgNC4yMSAwIDAgNC4yMSAxMi42MyAxNi43NyAwLjA3IDI5LjI2IDQuMDYgMzMuMjUgMTYuNyAyMC43NiAyOS4yNiAzMy4yNSAzMy40IDI5LjExIDIwLjg0IDE2LjYzIDMzLjMyIDQuMDYgMjkuMzMgMCIvPjwvc3ZnPg=="

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(423)
	
	var Component = __webpack_require__(166)(
	  /* script */
	  __webpack_require__(174),
	  /* template */
	  __webpack_require__(442),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(422)
	
	var Component = __webpack_require__(166)(
	  /* script */
	  __webpack_require__(175),
	  /* template */
	  __webpack_require__(441),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 441:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "video-overlay"
	    },
	    on: {
	      "click": _vm.toggleVideo
	    }
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "video-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "video"
	    }
	  })])
	}]}

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.titleActive && _vm.$route.name !== "video") ? _c('div', {
	    staticClass: "title",
	    on: {
	      "click": function($event) {
	        _vm.titleActive = false
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "id": "title",
	      "src": _vm.titleImg
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "id": "close",
	      "src": _vm.closeIcn
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "mobile-nav about",
	    class: {
	      hidden: _vm.navHidden
	    },
	    on: {
	      "click": _vm.showMobileAbout
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mobile-nav quotes",
	    class: {
	      hidden: _vm.navHidden
	    },
	    on: {
	      "click": _vm.showMobileQuotes
	    }
	  }), _vm._v(" "), (_vm.$route.name !== "video") ? _c('div', {
	    staticClass: "colophon",
	    on: {
	      "click": _vm.toggleNavigation
	    }
	  }, [_c('vue-typer', {
	    attrs: {
	      "text": _vm.colophonText
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "quart credits",
	    class: {
	      collapsed: _vm.quotesCollapsed, hidden: _vm.navHidden, 'show-mobile': _vm.mobileQuotes
	    },
	    attrs: {
	      "id": "credits"
	    }
	  }, [_c('div', {
	    staticClass: "toggle-area",
	    on: {
	      "click": _vm.toggleQuotes
	    }
	  }), _vm._v(" "), (_vm.$route.name == "video") ? _c('p', [_c('router-link', {
	    staticClass: "colophon-link",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Colophon >")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name == "home" && _vm.main.biographies) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.main.biographies)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.$route.name == "video" && _vm.main.single.data.credits && _vm.main.single.data.credits) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.main.single.data.credits)
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "quart about",
	    class: {
	      collapsed: _vm.aboutCollapsed, hidden: _vm.navHidden, 'show-mobile': _vm.mobileAbout
	    },
	    attrs: {
	      "id": "about"
	    }
	  }, [_c('div', {
	    staticClass: "toggle-area",
	    on: {
	      "click": _vm.toggleAbout
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "header"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [(_vm.$route.name == "video" && _vm.main.single.data && _vm.main.single.data.text[0]) ? _c('pre', [_vm._v(_vm._s(_vm.main.single.data.text[0].text))]) : _vm._e(), _vm._v(" "), (_vm.$route.name == "home" && _vm.main.about.data && _vm.main.about.data.text[0]) ? _c('pre', [_vm._v(_vm._s(_vm.main.about.data.text[0].text))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "quart index",
	    class: {
	      collapsed: _vm.indexCollapsed, hidden: _vm.navHidden
	    },
	    attrs: {
	      "id": "index"
	    }
	  }, [(_vm.indexCollapsed) ? _c('div', {
	    staticClass: "toggle-area",
	    on: {
	      "click": _vm.toggleIndex
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === "video" && _vm.indexCollapsed) ? _c('div', {
	    staticClass: "vertical-title"
	  }, [(_vm.main.single.data && _vm.main.single.data.title && _vm.main.single.data.title[0]) ? _c('span', [_vm._v(_vm._s(_vm.main.single.data.title[0].text))]) : _vm._e(), _vm._v(" "), (_vm.main.single.data && _vm.main.single.data.media && _vm.main.single.data.media[0] && _vm.main.single.data.media[0].length > 0) ? _c('span', [_vm._v(", " + _vm._s(_vm.main.single.data.media[0].text))]) : _vm._e(), _vm._v(" "), (_vm.main.single.data && _vm.main.single.data.year[0] && _vm.main.single.data.year[0].length > 0) ? _c('span', [_vm._v(", " + _vm._s(_vm.main.single.data.year))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "txt top"
	  }, [_c('p', {
	    staticClass: "left"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "right"
	  }, [_c('span', {
	    staticClass: "index-switch",
	    class: {
	      "active": _vm.textIndex
	    },
	    on: {
	      "click": function($event) {
	        _vm.textIndex = true;
	        _vm.imageIndex = false;
	      }
	    }
	  }, [_vm._v("tracks")]), _vm._v(" |\n        "), _c('span', {
	    staticClass: "index-switch",
	    class: {
	      "active": _vm.imageIndex
	    },
	    on: {
	      "click": function($event) {
	        _vm.imageIndex = true;
	        _vm.textIndex = false;
	      }
	    }
	  }, [_vm._v("images")])])]), _vm._v(" "), (_vm.imageIndex) ? _c('div', {
	    staticClass: "image-index"
	  }, [_c('div', {
	    staticClass: "preloader"
	  }, _vm._l((_vm.main.works), function(item) {
	    return _c('img', {
	      attrs: {
	        "src": item.data.images[0].image.url
	      }
	    })
	  })), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "img-slide-wrapper"
	    }
	  }, [_c('div', [_c('router-link', {
	    attrs: {
	      "to": _vm.main.works[_vm.imageSlider.index].slugs[0]
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.main.works[_vm.imageSlider.index].data.images[0].image.url
	    }
	  })])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "slide-navigation"
	  }, [_c('div', {
	    staticClass: " nav-arrow"
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imageSlider.index !== 0),
	      expression: "imageSlider.index !==0"
	    }],
	    on: {
	      "click": function($event) {
	        _vm.imageSlider.index--
	      }
	    }
	  }, [_vm._v("<")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.main.works[_vm.imageSlider.index].data.title[0].text))]), _vm._v(" "), _c('div', {
	    staticClass: "nav-arrow"
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imageSlider.index < (_vm.main.works.length - 1)),
	      expression: "imageSlider.index < (main.works.length - 1)"
	    }],
	    on: {
	      "click": function($event) {
	        _vm.imageSlider.index++
	      }
	    }
	  }, [_vm._v(">")])])])]) : _vm._e(), _vm._v(" "), (_vm.textIndex) ? _c('div', {
	    staticClass: "text-index"
	  }, [_c('ol', _vm._l((_vm.main.works), function(work) {
	    return _c('li', [_c('router-link', {
	      staticClass: "text-index-item",
	      attrs: {
	        "to": work.slugs[0]
	      }
	    }, [_c('div', {
	      staticClass: "index-number"
	    }, [(work.data.order < 10) ? _c('span', [_vm._v("0")]) : _vm._e(), _vm._v(_vm._s(work.data.order) + ".\n            ")]), _vm._v(" "), _c('div', {
	      staticClass: "index-title"
	    }, [(work.data.title && work.data.title[0]) ? _c('span', [_vm._v(_vm._s(work.data.title[0].text))]) : _vm._e()])])], 1)
	  }))]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('router-view', {
	    on: {
	      "hideNav": _vm.hideNavigation
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.84c045f0073cf8232f1a.js